import React, { useEffect, useState, useCallback } from 'react'
import axios from 'axios';
import { useSelector } from 'react-redux';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';

// import faker from 'faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export default function ChartSection() {
    const [FbIncData, setFBIncData] = useState([]);
    const [FbDecData, setFBDecData] = useState([]);

    const Sinceselector = useSelector((state) => {
        return state.SinceDates
    });

    const untilSelector = useSelector((state) => {
        return state.UntilDates
    })

    const Filter = useSelector((state) => {
        return state.Filter
    })

    const GetAnalytics = useCallback(async () => {
        const FilterProfile = [];
        var token;

        if (Filter.length > 0 && Filter[0]) {
            Filter[0].forEach((elem) => {
                if (elem.platform === "FACEBOOK") {
                    FilterProfile.push(elem.platform_id)
                }
                else {
                    FilterProfile.push(elem.platform_id)
                }
            })
        }


        if (localStorage.getItem('user_Token')) {
            token = localStorage.getItem('user_Token');
        }
        else {
            token = sessionStorage.getItem('user_Token');
        }

        const since = new Date(Sinceselector[0] * 1000)
        const until = new Date(untilSelector[0] * 1000);

        axios.post(`${process.env.REACT_APP_BACKEND_API}/group/group-analytics`, {
            "groupName": localStorage.getItem("oolook_default_group"),
            "selectedProfiles": FilterProfile,
            "since": since.getFullYear() + "-" + (since.getMonth() + 1).toString().padStart(2, "0") + "-" + since.getDate().toString().padStart(2, "0"),
            "until": until.getFullYear() + "-" + (until.getMonth() + 1).toString().padStart(2, "0") + "-" + until.getDate().toString().padStart(2, "0")
        }, {
            headers: {
                'Authorization': `Barear ${token}`
            }
        })
            .then((res) => {
                const fbData = res.data.analytics.FACEBOOK || [];
                const newFbIncData = [];
                const newFbDecData = [];

                fbData.forEach((elem) => {
                    const pageFollows = elem.data.find(d => d.name === "page_daily_follows");
                    const pageUnfollows = elem.data.find(d => d.name === "page_daily_unfollows");

                    if (pageFollows) {
                        newFbIncData.push(...pageFollows.values);
                    }
                    if (pageUnfollows) {
                        newFbDecData.push(...pageUnfollows.values);
                    }
                });
                setFBIncData(newFbIncData);
                setFBDecData(newFbDecData);
            })
            .catch((err) => {
                console.log(err)
            })
    }, [Filter, Sinceselector, untilSelector]);

    useEffect(() => {
        if (Filter.length !== 0) { 
            GetAnalytics()
        }
    }, [Sinceselector, untilSelector, Filter, GetAnalytics])

    return (
        <>
            <div className='chart_section'>
                <div className='chart_heading d-flex flex-column px-3 py-3'>
                    <label className='label_head'>
                        Audience Growth
                    </label>

                    <label className='label_sub_head'>
                        See how your audience grew during the reporting period.
                    </label>
                </div>
           </div>
        </>
    );
}